module.exports = __webpack_public_path__ + "img/kogata.8e4252f0.gif";